export default __webpack_public_path__ + "static/media/Q8-3.bd42da7b.jpg";